
namespace TabAurous.HR {
    @Serenity.Decorators.panel()
    @Serenity.Decorators.registerClass()
    export class AttendanceDialog extends _Ext.DialogBase<AttendanceRow, any> {
        protected getFormKey() { return AttendanceForm.formKey; }
        protected getIdProperty() { return AttendanceRow.idProperty; }
        protected getLocalTextPrefix() { return AttendanceRow.localTextPrefix; }
        protected getNameProperty() { return AttendanceRow.nameProperty; }
        protected getService() { return AttendanceService.baseUrl; }
        protected getDeletePermission() { return AttendanceRow.deletePermission; }
        protected getInsertPermission() { return AttendanceRow.insertPermission; }
        protected getUpdatePermission() { return AttendanceRow.updatePermission; }

        protected form = new AttendanceForm(this.idPrefix);

        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 500;
            q.initDetailEditor(this, this.form.Details, Config);
            q.hideEditorLabel(this.form.Details);

        }
        protected onDialogOpen() {
            super.onDialogOpen();
        }
        protected validateBeforeSave() {
            var returnvalue = super.validateBeforeSave();
            var employees = this.form.Details.getItems();
            for (var i = 0; i < employees.length; i++) {
                var employee = employees[i];
                returnvalue = false;
                if (employee.Present || employee.Absent || employee.HalfDay || employee.OnLeave) {                    
                    returnvalue = true;
                } else {
                    q.alert('', 'No attendance marked for ' + employee.EmployeeName, true, 2999);
                    returnvalue = false;
                    return returnvalue;

                }
            }
            return returnvalue;
        }
    }
}